import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React, { useEffect, useState } from 'react';
import { Typography, CircularProgress, ThemeProvider } from '@mui/material';
import { CostCenterAccordion } from './CostCenterAccordion.jsx';
import { BackendErrorAlert } from '../shared/BackendErrorAlert.jsx';
import { buttonsTheme } from '../shared/_theme.jsx';

export default class MainCostCenterAccordion extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */

    static getReactComponent($) {
        return (props) => {
            const operation = useProperty($, 'Operation');
            const isOpen = useProperty($, 'Is Open');
            const loading = useProperty($, 'Loading');
            const costCentersData = useProperty($, 'Data');

            const [openNoFetchAlert, setOpenNoFetchAlert] = useState(false);

            useEffect(() => {
                if (costCentersData && costCentersData.flat(1).length === 0) {
                    setOpenNoFetchAlert(true);
                }
            }, [costCentersData]);

            const handleCloseNoFetchDialog = () => {
                setOpenNoFetchAlert(false);
            };

            const getId = (item) => (operation === 'PO' ? item.PurchGroup : item.CostCenterId || item.CostElementId);
            const getDescription = (item) => (operation === 'PO' ? item.PurchGroupName : item.costCenterDescription);

            return (
                <ThemeProvider theme={buttonsTheme}>
                    <div className={'accordion-container show-scrollbar'}>
                        {loading ? (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                <CircularProgress color="primary" sx={{ margin: '1vw' }} />
                                <Typography variant="h5" color="primary">
                                    Loading...
                                </Typography>
                            </div>
                        ) : (
                            isOpen &&
                            costCentersData &&
                            costCentersData.length > 0 &&
                            costCentersData
                                .flat(1)
                                .sort((a, b) => getId(a).localeCompare(getId(b)))
                                .map((costCenter, idx) => {
                                    const key =
                                        idx +
                                        getId(costCenter) +
                                        costCenter.RelGroup +
                                        costCenter.RelCode +
                                        costCenter.RelStrategy;
                                    return (
                                        <CostCenterAccordion
                                            key={key}
                                            item={costCenter}
                                            itemId={getId(costCenter)}
                                            itemDescription={getDescription(costCenter)}
                                            accordionIdx={idx}
                                            context={$}
                                        />
                                    );
                                })
                        )}
                        {openNoFetchAlert && (
                            <BackendErrorAlert
                                title={'Fetch Error'}
                                open={openNoFetchAlert}
                                onClose={handleCloseNoFetchDialog}
                                mainLine={BackendErrorAlert.NO_RESULTS_EXPLANATION}
                                smallLine1={BackendErrorAlert.CHANGE_CRITERIA}
                            />
                        )}
                    </div>
                </ThemeProvider>
            );
        };
    }
}

registerBrick('017fbc3f4d237b5fc55b', MainCostCenterAccordion);
